<span class="text" [innerHTML]="linkifyContent | linkify"></span>
<span style="color:#039be5" class="cursor-pointer" *ngIf="show"
      (click)="toggleContent()"> {{ (isContentToggled ? 'post.show_less' : 'post.show_more') | translate}}</span>
